import React from "react";
import { Global } from "@emotion/react";

export const Fonts: React.FC = () => (
  <Global
    styles={`
      html {
        font-size: 16px;
      }

      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 300;
        font-display: swap;
        src: url('/fonts/Inter-Light.woff2') format('woff2');
      }

      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/Inter-Regular.woff2') format('woff2');
      }

      @font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/Inter-Bold.woff2') format('woff2');
      }
      `}
  />
);
